
export default function (Component) {
  Component.options.__source = "src/components/SelectTree/index.vue"
}
